import { CANCELORDER_SUBMIT, CANCELORDER_SUBMIT_ERROR, CANCELORDER_SUBMIT_SUCCESS } from './constants';

const initialState = {
    isFetching: false,
    isSubmitted: false,
};

export { initialState };

export default (state = initialState, action) => {
    switch (action.type) {
        case CANCELORDER_SUBMIT:
            return {
                ...state,
                isFetching: true,
                isSubmitted: false,
            };
        case CANCELORDER_SUBMIT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                isSubmitted: true,
            };
        case CANCELORDER_SUBMIT_ERROR:
            return {
                ...state,
                isFetching: false,
                isSubmitted: false,
            };
        default:
            return state;
    }
};
